/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPostThreadV2.defs.js'
export * as $defs from './getPostThreadV2.defs.js'
